import React, { useEffect } from "react";
import _ from "lodash";
import cx from "classnames";

import { SearchBar } from "src/components/input";

import { animated } from "@react-spring/web";
import { StoryBoard, WorkSpace } from "src/types/cleverstory";
import { TabBar } from "src/components/tabbar";

import { useDispatch } from "react-redux";
import { fetchStoryBoardsForWorkSpace, invalidateCleverstoryWorkspaces } from "src/redux/actions/cleverstory";
import { useSelector } from "react-redux";
import CleverStoryBrowser, { StoryBoardPlaceholder } from "./workspaceBrowser";
import InfiniteScroll from "src/components/infiniteScroll";
import { Asset } from "src/types/assets";
import { Collection } from "src/types/collections";
import { IntegraionService } from "src/services/integration.service";

import styles from "./cleverstory.module.scss";

interface AddAssetFromCleverStoryProps {
  style: any;
  // eslint-disable-next-line no-unused-vars
  onSelection: (entity: any) => void;
  // eslint-disable-next-line no-unused-vars
  selectedAssets: (Asset | Collection)[];
}

const AddAssetFromCleverStory: React.FC<AddAssetFromCleverStoryProps> = ({
  style,
  onSelection,
  selectedAssets,
}) => {
  const dispatch = useDispatch();
  const [query, setQuery] = React.useState<string | null>("");
  const [selectedtab, setSelectedTab] = React.useState<number>(0);
  const [workspace, setWorkspace] = React.useState<WorkSpace | null>(null);

  const workspaces = useSelector((state: any) => {
    return _.get(state, "cleverStory.workspaces").map((workspace: any) => {
      return _.get(workspace, "item") as WorkSpace;
    });
  });

  const { loading, storyboards, currentPage, nextPage, hasMoreStoryBoards } = useSelector((state: any) => {
    const workspaceItem = (_.get(state, "cleverStory.workspaces") || []).find(item => {
      const id = _.get(item, "item.workspace");
      if (id === workspace?.workspace) {
        return item;
      }
    });

    if (!workspaceItem) {
      return {
        loading: false,
        storyboards: [],
        currentPage: -1,
        nextPage: null,
        hasMoreStoryBoards: false,
      };
    }

    const loading = _.get(workspaceItem, "storyboards.loading", false);
    const items = (_.get(workspaceItem, "storyboards.items") || [])
      .map((storyboard: any) => {
        return _.get(storyboard, "item") as StoryBoard;
      }).filter((storyboard: any) => {
        const storyBoardType = IntegraionService.getStoryBoardType(_.get(storyboard, "page.storyboardType", ''))
        return !(storyBoardType === "Interactive experience" && !_.get(storyboard, "page.published", false));
      });

    const pagination = _.get(workspaceItem, 'storyboards.pagination');
    const total = _.get(pagination, "totalPages", 0);
    const hasMoreItems = _.get(pagination, "hasMoreItems");

    let nextPage: number | null = _.get(pagination, "currentPage", 0) + 1;
    if (nextPage && nextPage >= total) {
      nextPage = null;
    }

    return {
      loading: loading,
      storyboards: items,
      hasMoreStoryBoards: hasMoreItems,
      nextPage: nextPage,
      currentPage: _.get(pagination, "currentPage", 0)
    };
  });

  const workspaceId = _.get(workspace, `workspace`);

  useEffect(() => {
    setWorkspace(workspaces[selectedtab]);
    if (workspaceId && (_.size(storyboards) === 0 || query)) {
      dispatch(
        fetchStoryBoardsForWorkSpace({
          workspace: workspaceId,
          query: query ? query : "",
          page: 0,
          limit: 20,
        }),
      );
    }
  }, [selectedtab, workspaceId]);

  useEffect(() => {
    if (workspaceId && query === '') {
      dispatch(fetchStoryBoardsForWorkSpace({
        workspace: workspaceId,
        page: 0,
        limit: 20,
      }));
    }
  }, [query, workspaceId]);

  const handleQueryChange = (value: string | null) => {
    if (workspaceId) {
      setQuery(value);
      if (value) {
        dispatch(
          fetchStoryBoardsForWorkSpace({ workspace: workspaceId, query: value, page: 0, limit: 20 }),
        );
      } else {
        dispatch(fetchStoryBoardsForWorkSpace({ workspace: workspaceId, page: 0, limit: 20 }));
      }
    }
  };

  const loadMoreStoryBoards = () => {
    if (!nextPage) {
      return;
    }

    dispatch(
      fetchStoryBoardsForWorkSpace({
        workspace: workspaceId!,
        page: nextPage,
        limit: 20,
        query: query ? query : "",
      }),
    );
  };
  return (
    <animated.div style={style} className={styles.container}>
      <div className={styles.searchBar}>
        <SearchBar query={query} onSearch={handleQueryChange} />
      </div>

      <div className={styles.tabsContainer}>
        <TabBar
          gap={32}
          tabSize="equal"
          active={selectedtab}
          className={cx(styles.tabBar, {[styles.single]: _.size(workspaces) === 1})}
          onSelectionChange={(tab) => setSelectedTab(tab)}
        >
          {workspaces.map((workSpace: WorkSpace, index) => (
            <span
              key={workSpace.id}
              className={cx(styles.tabs, {
                [styles.active]: selectedtab === index,
              })}
            >
              {workSpace?.workspaceName}
            </span>
          ))}
        </TabBar>

        <InfiniteScroll
          loading={loading}
          loadMore={loadMoreStoryBoards}
          hasMore={hasMoreStoryBoards}
          className={styles.storyBoardContainer}
          loader={() => {
            return _.times(currentPage === 0 ? 3 : 1, (index) => (
              <StoryBoardPlaceholder key={index} />
            ));
          }}
        >
          {!loading && _.size(storyboards) === 0 && <p className={styles.storyboardsLoading}> No results found </p>}
          <CleverStoryBrowser
            selectedAssets={selectedAssets}
            onSelection={onSelection}
            storyboards={storyboards}
            workspace={workspaceId!}
          />
        </InfiniteScroll>
      </div>
    </animated.div>
  );
};

export default AddAssetFromCleverStory;
